// extracted by mini-css-extract-plugin
export var text = "_4x-0";